import {Buffer} from "buffer";
import {loadIcons} from "@mytour/ui/icon-loader";
import {initAnalytics} from "./analytics.js";
import {initAxios, setupAxiosInterceptors} from "./axios-interceptor.js";
import {initDayjs} from "./dayjs.js";
import {initI18n} from "./i18n.js";
import {initSentry} from "./sentry.js";
export * from "./account/AccountSettingsPage.js";
export * from "./analytics.service.js";
export * from "./analyticsSession.js";
export * from "./account/query/accountQueries.js";
export * from "./account/query/platformUserQueries.js";
export * from "./account/query/useJobCategoryFeatures.js";
export * from "./account/query/useTeamMode.js";
export * from "./account/query/teamMemberQueries.js";
export * from "./authentication/authenticationApi.service.js";
export * from "./authentication/authenticationQueries.js";
export * from "./contextQueries.js";
export * from "./googleQueries.js";
export * from "./HasRole.js";
// Only the hook is public API; getFeatureFlagSnapshot / subscribeFeatureFlags
// stay module-internal (imported directly by their unit test).
export {useFeatureFlag} from "./useFeatureFlag.js";
export {useTrackPlanningViewed} from "./useTrackPlanningViewed.js";
export {geocodeConfirmationAnalytics} from "./geocodeConfirmationAnalytics.js";
export {useAddressVerification} from "./useAddressVerification.js";
export {useSiretLookup, siretLookupKeysStore} from "./useSiretLookup.js";

export * from "./axios-interceptor.js";
export {
  createDiagnosticOperationId,
  diagnosticFetch,
  recordDiagnosticOutcome,
  reportBrowserError,
  withDiagnosticStep,
} from "./diagnostics/networkDiagnostics.js";
export * from "./dayjs.js";
export * from "./i18n.js";
export * from "./pagination.constants.js";
export * from "./services/date.service.js";
export * from "./services/download.service.js";
export * from "./services/entity.service.js";
export * from "./services/env.service.js";
export * from "./services/error.service.js";
export * from "./services/event.service.js";
export * from "./services/geocode.service.js";
/**
 * Export explicite : `shouldRetryQuery` est un détail d'implémentation de la
 * politique de retry, pas un contrat entre workspaces.
 */
export {queryService} from "./services/query.service.js";
export * from "./services/siret.service.js";

export * from "./utils/file.util.js";
export * from "./utils/prepareReportPhotos.js";
export * from "./utils/format.util.js";
export * from "./utils/lazyWithReload.js";
export * from "./utils/moderationChurnedContinue.util.js";
export * from "./utils/pagination.util.js";
export * from "./utils/storage.util.js";

export {Brand} from "./menus/Brand.js";

export function initPlatform() {
  initAxios();
  initDayjs();
  initI18n();
  initSentry();
  initAnalytics();
  // Make Buffer available globally for browser compatibility
  window.Buffer = Buffer;
  loadIcons();
  setupAxiosInterceptors();
}

export * from "./services/customerAppointmentKeys.js";

export {AppointmentEmptyState} from "./empty-screens/AppointmentEmptyState.js";
